export const light = (value: string): string =>
  replaceAlpha(value, 0.7)

export const lighter = (value: string): string =>
  replaceAlpha(value, 0.2)

const replaceAlpha = (value: string, alpha: number): string =>
  value?.replace(/[\d\.]+\)/ig, `${alpha})`)